// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3T3oN","col":"styles_col__2AQ8M"};